export default "__VITE_ASSET__Dqy2Nfys__"